import {MemberDirectConfigReducerState} from './config.interfaces';

export const memberDirectConfigInitialState: MemberDirectConfigReducerState = {
    companyName: null,
    logo: null,
    language: null,
    defaultLanguage: 'en',
    quote: null,
    isNextGen: false,
    isMovePage: false
};
